/**
 * Why a coupon was refused — from the refusal's CODE, in the reader's language.
 * (BL-213 coupons · every coupon field, web and mobile)
 *
 * The web coupon field used to show the server's `message` ("Coupon 'X' is
 * expired or not yet active"): English on every locale. The coupon service
 * raises a typed error per reason (`AFFILIATE_001`–`005`); each gets copy that
 * says what is wrong with the code, and anything else the generic "not valid"
 * line. Keys are literal, so the key-usage gate checks each one.
 */
import { apiErrorCode, DOMAIN_ERROR_CODES } from '@tonnie/foundation';

import type { PricingTranslate } from './pricing-display';

export function couponErrorMessage(err: unknown, t: PricingTranslate): string {
  switch (apiErrorCode(err)) {
    case DOMAIN_ERROR_CODES.AFFILIATE_001:
      return t('payment.coupon.errors.notFound');
    case DOMAIN_ERROR_CODES.AFFILIATE_002:
      return t('payment.coupon.errors.expired');
    case DOMAIN_ERROR_CODES.AFFILIATE_003:
      return t('payment.coupon.errors.disabled');
    case DOMAIN_ERROR_CODES.AFFILIATE_004:
      return t('payment.coupon.errors.exhausted');
    case DOMAIN_ERROR_CODES.AFFILIATE_005:
      return t('payment.coupon.errors.wrongProduct');
    default:
      return t('payment.coupon.invalid');
  }
}
